import React from 'react';
import PropTypes from 'prop-types';
import animate from 'app/helpers/animations/donut';

export default class Donut extends React.Component {
  static defaultProps = {
    percentage: 0,
    dimension: 50,
  };

  static propTypes = {
    percentage: PropTypes.number.isRequired,
    dimension: PropTypes.number.isRequired,
  };

  componentDidMount() {
    animate(this.props.percentage);
  }

  makeCircle = ({ ...rest }) => (
    <circle
      {...rest}
      r={15.91549430918952}
      strokeDashoffset={25}
      cx={20}
      cy={20}
      transform={`scale(${this.props.dimension / 40})`}
      fill="none"
      strokeWidth={8}
    />
  );

  render() {
    const { makeCircle, props: { percentage, dimension } } = this;
    const color =
      percentage <= 25
        ? 'red'
        : percentage <= 50 ? 'orange' : percentage <= 75 ? 'yellow' : 'green';

    return (
      <svg
        width={dimension}
        height={dimension}
        className={`donut-${percentage}`}
      >
        <linearGradient id="red" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F44336" />
          <stop offset="100%" stopColor="#D85C52" />
        </linearGradient>
        <linearGradient id="orange" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#FF5722" />
          <stop offset="100%" stopColor="#FF9800" />
        </linearGradient>
        <linearGradient id="yellow" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#ffc107" />
          <stop offset="100%" stopColor="#FACC70" />
        </linearGradient>
        <linearGradient id="green" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#8bc34a" />
          <stop offset="100%" stopColor="#8CB564" />
        </linearGradient>
        {makeCircle({ stroke: '#f8f8f8' })}
        {makeCircle({
          strokeDasharray: `${percentage} ${100 - percentage}`,
          stroke: `url(#${color})`,
        })}
      </svg>
    );
  }
}
